<div class="malfunction-filter__section">
  <div class="malfunction-filter__title">{{ "Malfunction.FilterOnImpact" | translate }}</div>
  <filter-bar
    filterTitle="{{ 'Malfunction.Impact.DownTime' | translate }}"
    filterType="impact"
    filterValue="Down"
    filterClassActive="active"
    [filterDefaultActive]="true"
  ></filter-bar>
  <filter-bar
    filterTitle="{{ 'Malfunction.Impact.ResilienceLoss' | translate }}"
    filterType="impact"
    filterValue="Resilience_loss"
    filterClassActive="active"
    [filterDefaultActive]="true"
  ></filter-bar>
  <filter-bar
    filterTitle="{{ 'Malfunction.Impact.ReducedRedundancy' | translate }}"
    filterType="impact"
    filterValue="Reduced_redundancy"
    filterClassActive="active"
    [filterDefaultActive]="true"
  ></filter-bar>
  <filter-bar
    filterTitle="{{ 'Malfunction.Impact.NoImpact' | translate }}"
    filterType="impact"
    filterValue="No_impact"
    filterClassActive="active"
    [filterDefaultActive]="false"
  ></filter-bar>
</div>
